var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    [
      _vm._l(_vm.righeReintegro, function (row, i) {
        return [
          i > 0 ? _c("v-divider", { key: "d_" + i }) : _vm._e(),
          _c(
            "v-row",
            {
              key: "r_" + i,
              staticStyle: { "background-color": "#f2f2f2" },
              attrs: { "no-gutters": "" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "col-indice",
                  attrs: { "align-self": "center" },
                },
                [
                  _c("p", { staticClass: "text-center" }, [
                    _vm._v(_vm._s(row.id)),
                  ]),
                ]
              ),
              _c(
                "v-col",
                { staticClass: "col-dati" },
                [
                  _c("div", [
                    _vm._v(" Componente: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(row.componente) +
                          " (" +
                          _vm._s(row.idComponenteBga) +
                          ")"
                      ),
                    ]),
                    _c("br"),
                    _vm._v("Descrizione modello: "),
                    _c("strong", [_vm._v(_vm._s(row.descrizione))]),
                    _c("br"),
                    _vm._v("Colore: "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(row.coloreDecodificato.codiceColore) +
                          " - (" +
                          _vm._s(row.coloreDecodificato.descrizione) +
                          ")"
                      ),
                    ]),
                    _vm._v(" , Unità di misura: "),
                    _c("strong", [_vm._v(_vm._s(row.unitaMisura))]),
                  ]),
                  _vm.userIsAdmin
                    ? _c("div", [
                        _vm._v(
                          "Fornitore: " +
                            _vm._s(_vm.nomeFornitore(row.idFornitore))
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "router-link",
                    {
                      attrs: {
                        to: { name: "riga", params: { id: row.idLavorazione } },
                      },
                    },
                    [_c("div", [_vm._v("LAVORAZIONE ASSOCIATA")])]
                  ),
                  _c("br"),
                  _vm._v("Quantità da integrare per taglia: "),
                  _c(
                    "ul",
                    _vm._l(_vm.quantitaPerTaglia(row), function (qta, index) {
                      return _c("li", { key: "li_" + index }, [
                        _c("div", { staticClass: "gray" }, [
                          _vm._v(_vm._s(qta.desc)),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm._f("formatNumber")(qta.qta)) + " "
                        ),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }